const CELL_SELECTOR = ".backoffice-table__cell[data-tooltip]"

const isTruncated = (el) => {
  if (!el) return false
  return el.scrollWidth > el.clientWidth + 1
}

const syncCellTooltip = (cell) => {
  const inner = cell.querySelector(".backoffice-table__cell-inner") || cell
  cell.classList.toggle("is-truncated", isTruncated(inner))
}

const onEnter = (event) => {
  const cell = event.target.closest?.(CELL_SELECTOR)
  if (!cell) return
  syncCellTooltip(cell)
}

const onLeave = (event) => {
  const cell = event.target.closest?.(CELL_SELECTOR)
  if (!cell) return
  if (cell.contains(event.relatedTarget)) return
  cell.classList.remove("is-truncated")
}

export const initBackofficeTableTooltips = () => {
  if (document.documentElement.dataset.backofficeTableTooltipsInit === "true") return
  document.documentElement.dataset.backofficeTableTooltipsInit = "true"

  document.addEventListener("mouseover", onEnter)
  document.addEventListener("mouseout", onLeave)
}
